import { render, staticRenderFns } from "./Playbar.vue?vue&type=template&id=7aa138fe&scoped=true"
import script from "./Playbar.vue?vue&type=script&lang=js"
export * from "./Playbar.vue?vue&type=script&lang=js"
import style0 from "./Playbar.vue?vue&type=style&index=0&id=7aa138fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa138fe",
  null
  
)

export default component.exports